const header = {
  homepage: 'https://igormomc.com',
  title: 'IGOR.',
}

const about = {
  name: 'Igor Momcilovic',
  role: 'Full Stack Engineer',
  description:
  'I’m a software engineer at Kahoot! | Graduated with a Master\'s in Computer Science from the University of Oslo. ' +
  'Passionate about building great products and writing clean, efficient code.',
  resume: 'https://example.com',
  social: {
    linkedin: 'https://www.linkedin.com/in/igor-momcilovic-b61b85207/',
    github: 'https://github.com/igormomc',
  },
}

const skills = [
  'HTML',
  'CSS',
  'JavaScript',
  'TypeScript',
  'React',
  'Kotlin',
  'Vue',
  'C',
  'Python',
  'Java',
  'SQL',
  'Material UI',
  'Git',
  'Docker',
]

const contact = {
  email: 'igormomc@hotmail.com',
}

export { header, about, skills, contact }
